<div *ngIf="isShowLoader" class="overlay">
  <div class="spinner-border" role="status">
  </div>
</div>